<!--
 * @Author: Gaho
 * @Date: 2024-05-29 16:43:41
 * @LastEditors: Merlin
 * @LastEditTime: 2025-03-27 15:38:14
 * @Description: 
-->
<template>
    <GameSettingsButtonWrapper 
        :tool-tip="t.Fainess" 
        :enable="modelValue" 
        @click.self="onClick()"
    >
        <QIcon @click.self="onClick()" name="verified_user">
        </QIcon>
    </GameSettingsButtonWrapper>
    <ModalMobileFairness 
        :model-value="modelValue" 
        @update:model-value="onModelValue" 
        @handleClose="onClick" 
        @handlePrinciple="handlePrinciple"
    />
    <ModalMobilePrinciple 
        :model-value="principleVisible" 
        @update:model-value="handlePrinciple" 
    />
</template>
<script setup lang="ts">
import useTranslation from '~/i18n/useTransLation';
import useGlobalStore from '~/stores/global';
import { useUserStore } from '~/stores/user';

const userStore = useUserStore()
const globalStore = useGlobalStore()
const t = useTranslation()
const principleVisible = ref(false);

const props = defineProps({
    modelValue: {
        type: Boolean,
        default: false
    }
})
const emit = defineEmits(['update:modelValue'])

const onModelValue = (value) => {
    emit('update:modelValue', value)
}

const onClick = () => {
    if (userStore.isLoggedIn)
        emit('update:modelValue', !props.modelValue)
}
const handlePrinciple = () => {
    principleVisible.value = !principleVisible.value;
}
</script>